module.exports = __webpack_public_path__ + "static/img/15.930cb21.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/10/sp/15.png
// module id = fbVL
// module chunks = 0